var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"overflow":"hidden"}},[_c('TopNavBar'),_c('TopNavBar2',{staticClass:"tnb2none",attrs:{"id":"navbar2"}}),_c('blockGq1'),_c('blockGq2'),_c('form1'),_c('Footer1')],1)}
var staticRenderFns = []

export { render, staticRenderFns }